import React, { ReactElement } from "react";

import CheckPermissions from "../../CheckPermissions";

import { COMPONENTS } from "@utils/Constants";

export const AncillaryPricingBoundsLayoutLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: PricingBoundsLayout } = await import(
    "@workflows/ancillaries/configurations/pricing-bounds/pricing-bounds-layout/PricingBoundsLayout"
  );
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_PRICING_BOUNDS}>
      <PricingBoundsLayout />
    </CheckPermissions>
  );

  return { Component: WrappedRules };
};

export const AncillaryPricingBoundsLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: AncillaryPricingBounds } = await import("@workflows/ancillaries/configurations/pricing-bounds");
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_PRICING_BOUNDS}>
      <AncillaryPricingBounds />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};

export const AncillaryPricingBoundsJourneyLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: AncillaryPricingBounds } = await import("@workflows/ancillaries/configurations/pricing-bounds");
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_PRICING_BOUNDS}>
      <AncillaryPricingBounds tab={0} />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};

export const AncillaryPricingBoundsSegmentLazy = async (): Promise<{
  Component: () => React.ReactElement;
}> => {
  const { default: AncillaryPricingBounds } = await import("@workflows/ancillaries/configurations/pricing-bounds");
  const WrappedRules = (): ReactElement => (
    <CheckPermissions name={COMPONENTS.ANCILLARIES_PRICING_BOUNDS}>
      <AncillaryPricingBounds tab={1} />
    </CheckPermissions>
  );
  return { Component: WrappedRules };
};
